























import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State, Getter } from 'vuex-class';
import Navbar from './Navbar.vue';
import BaseNavDropdown from '@/components/base/BaseNavDropdown.vue';
import { NavLink } from '@/jbi-shared/types/Nav';
import { Profile } from '@/store/modules/profile/profile.state';
import { get as _get } from 'lodash';
import { RootState } from '@/store/store';
import { stringify } from 'qs';

@Component({
  components: {
    Navbar,
    BaseNavDropdown
  }
})
export default class AppNavbar extends Vue {
  @Getter('userAttribute/isMissingAttributeValue')
  public isMissingAttributeValue!: boolean;

  @Action('getMe', {
    namespace: 'profile'
  })
  public getMe!: () => void;

  @State('profile', {
    namespace: 'profile'
  })
  public profile!: Profile;

  @State(({ auth }: RootState) => auth.isLoggedIn)
  isLoggedIn!: boolean;

  get VUE_APP_BACKEND_HOSTNAME(): string {
    return process.env.VUE_APP_BACKEND_HOSTNAME || '';
  }

  get signupURL() {
    const redirectionQuery = stringify({
      destination: window.location.href
    });

    return `${this.VUE_APP_BACKEND_HOSTNAME}/login?${redirectionQuery}`;
  }

  get userName(): string {
    const firstName = _get(this.profile, 'firstName', '');
    const lastName = _get(this.profile, 'lastName', '');
    return firstName && lastName ? `${firstName} ${lastName}` : '';
  }

  get userEmail(): string {
    return _get(this.profile, 'email');
  }

  get navLinks(): NavLink[] {
    // @ts-ignore
    const routeFilter = this.$root.getNavLinks().map((res) => {
      const notAllowed: boolean =
        this.isMissingAttributeValue && !res.url?.includes('/logout');
      // Account can be opened in admin context with extra query params
      // (userId/isAdminUser). Use fullPath check so clicking Account can
      // still reset back to the current user's /account?tab=profile page.
      const isAccountLink = (res.label || '').toLowerCase() === 'account';
      const isCurrentRoute = isAccountLink
        ? this.$router.resolve(res.to).route.fullPath === this.$route.fullPath
        : res.to?.name === this.$route.name;
      if (isCurrentRoute) {
        return {
          ...res,
          disable: true,
          notAllowed
        };
      }
      return {
        ...res,
        notAllowed
      };
    });
    // @ts-ignore
    return routeFilter || [];
  }
}
